module.exports = __webpack_public_path__ + "static/media/reg9.2e1926cb.jpg";